<template>
  <div
    ref="observe_element"
  >
    <span v-if="isApiError">通信に失敗しました。<br>しばらくしてから再度お試しください。</span>
    <div class="sectionBtn">
      <button
        id="balloon_follow"
        v-tooltip.right="{
          content:
            'フォローすると、この企業がプレスリリースを配信した際に、メールで受信することができます。',
        }"
        class="list list-center list-align cheer_follow"
        :class="{ follow: !isFollow, following: isFollow }"
      >
        <div class="svg_follow">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 12"
          >
            <defs />
            <title>icon_follow</title>
            <g
              id="layer_follow"
              data-name="layer_follow"
            >
              <g id="layer_follow_header">
                <rect
                  class="cls-3"
                  y="4.8"
                  width="12"
                  height="2.4"
                />
                <rect
                  class="cls-3"
                  y="4.8"
                  width="12"
                  height="2.4"
                  transform="translate(0 12) rotate(-90)"
                />
              </g>
            </g>
          </svg>
        </div>
        <p @click="toggleFollow">
          {{ followed ? "フォロー中" : "フォローする" }}
        </p>
      </button>
    </div>
    <div v-if="showModal">
      <Modal>
        <div class="popup_menu">
          <button
            type="button"
            class="closebtn"
            @click="closeModal"
          >
            <span>×</span>
          </button>
        </div>
        <div id="follow_box">
          <!-- FBログイン -->
          <div class="fb_login_box">
            <div style="max-width: 640px; padding: 20px;">
              <div
                style="width: 100%; color: #666; font-size: 20px; font-weight: bold; margin-bottom: 30px; text-align: center;"
              >
                ログインしてフォローしよう
              </div>
              <p
                style="font-size: 12px; color: #666; margin-bottom: 20px; text-align: center;"
              >
                フォローするにはFacebookアカウントが必要です。<br>valuepressが許可なくFacebookなどへ投稿することはありません。
              </p>
              <div
                v-if="fbSdkIsLoad"
                class="fb_login_guide"
                style="width: 100%; margin-bottom: 20px; text-align: center;"
              >
                <a>
                  <div class="fb-login-button FbBtn">
                    <span
                      class="FbBtnLabel"
                      @click="openFacebookLoginWindow"
                    >Facebookでログイン</span>
                  </div>
                </a>
              </div>
              <div
                v-else
                class="fb_login_loading"
                style="width: 100%; margin-bottom: 20px; text-align: center;"
              >
                Facebook 認証中<br>
                <img src="/static/image/column3_bx_loader.gif">
              </div>
              <div style="width: 100%; border-top: 1px #ededed solid; padding-top: 20px;">
                <p style="width: max-480px; color: #666; font-size: 14px; font-weight: bold; margin: 0 0 10px 60px;">
                  フォローするとは？
                </p>
                <div style="width: max-480px; font-size: 12px; line-height: 160%; color: #666; margin-left: 60px;">
                  フォローすると、フォローした企業がプレスリリースを配信した際に、メールで受信することができます。気になる企業の最新動向を把握するのに役立ちます。
                </div>
              </div>
            </div>
          </div>
          <!-- /FBログイン -->
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import Modal from "./Modal.vue";
import { loadSDK } from "~/common/facebook_sdk_load";
import { FacebookLogin } from "./Mixins/FacebookLogin";
import MediumFollowsRepository from "~/repositories/MediumFollowsRepository";
import { registerMediumServiceworker } from "~/lib/Serviceworker";
import { axios } from "~/libs/vp-api-axios";

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default {
  name: "FollowBtn",
  components: { Modal },
  mixins: [FacebookLogin],
  props: {
    userAccountId: {
      type: Number,
      default: 0,
    },
    mediumId: {
      type: Number,
      default: 0
    },
    app: {
      type: Number,
      default: 0,
    },
    session: {
      type: String,
      default: "",
    },
    dummy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      followed: false,
      mounted: false,
      mediumFollow: {},
      isApiError: false,
      observer: null,
    };
  },
  computed: {
    fbSdkIsLoad() {
      return window.FB !== undefined;
    },
    isFollow() {
      return this.followed;
    },
  },
  mounted() {
    // 企業ページでメディアログインしていないとき
    if (location.pathname.match(/corporation/) && !this.mediumId) {
      loadSDK(this.app);
    }
    if (this.mediumId) {
      // メディアログインしているとき
      this.fetchMediumFollow();
    } else {
      // メディアログインしていないとき
      this.getLoginStatus();
    }
    this.setObserver();
    const observe_element = this.$refs.observe_element;
    this.observer.observe(observe_element);
  },
  updated() {
    if (window.FB !== undefined && !this.fbSdkIsLoaded && !this.mediumId) {
      this.getLoginStatus();
    }
  },
  methods: {
    // 表示されたらフォローの状況を取得する
    // 1ページに複数フォローボタンが表示される事があり、フォロー状況を同期するため
    // ref: https://github.com/radicodeinc/value_press/issues/12856
    setObserver() {
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        if (entry && entry.isIntersecting) {
          if (this.mediumId) {
            // メディアログインしているとき
            this.fetchMediumFollow();
          } else {
            // メディアログインしていないとき
            this.getLoginStatus();
          }
        }
      });
    },
    closeModal() {
      this.showModal = false;
    },
    toggleFollow() {
      if (this.dummy) {
        return;
      }
      // メディアログインしているとき
      if (this.mediumId) {
        if (this.followed) {
          this.destroyMediumFollow();
        } else {
          registerMediumServiceworker();
          this.createMediumFollow();
        }
      } else if (this.fbLogin) {
        if (this.followed) {
          this.unfollow();
        } else {
          this.follow();
        }
      } else {
        this.showModal = true;
      }
    },
    openFacebookLoginWindow() {
      this.facebookLogin();
      this.showModal = false;
    },
    async fetchMediumFollow() {
      try {
        this.isApiError = false;
        const repository = new MediumFollowsRepository();
        this.mediumFollow = await repository.show({ userAccountId: this.userAccountId });
        if (Object.keys(this.mediumFollow).length) {
          this.followed = true;
        } else {
          this.followed = false;
        }
      } catch (e) {
        this.isApiError = true;
        window.webpackBugsnagClient.notify(e);
      }
    },
    async createMediumFollow() {
      try {
        this.isApiError = false;
        const repository = new MediumFollowsRepository();
        this.mediumFollow = await repository.create({ mediumFollow: { userAccountId: this.userAccountId } });
        if (Object.keys(this.mediumFollow).length) this.followed = true;
      } catch (e) {
        this.isApiError = true;
        window.webpackBugsnagClient.notify(e);
      }
    },
    async destroyMediumFollow() {
      try {
        this.isApiError = false;
        const repository = new MediumFollowsRepository();
        await repository.destroy({ mediumFollow: { userAccountId: this.userAccountId } });
        this.mediumFollow = {};
        this.followed = false;
      } catch (e) {
        this.isApiError = true;
        window.webpackBugsnagClient.notify(e);
      }
    },
    follow() {
      this.isApiError = false;
      axios
        .post("/api/social_api/follow", { corporationId: this.userAccountId })
        .then(() => {
          this.followed = true;
        })
        .catch((result) => {
          this.isApiError = true;
          console.error(result);
        })
        .finally(() => {
          this.showModal = false;
        });
    },
    unfollow() {
      this.isApiError = false;
      axios
        .post("/api/social_api/unfollow", { corporationId: this.userAccountId })
        .then(() => {
          this.followed = false;
        })
        .catch((result) => {
          this.isApiError = true;
          console.error(result);
        })
        .finally(() => {
          this.showModal = false;
        });
    },
  },
};

</script>
<style lang="scss" scoped>
.popup_menu {
  text-align: right;
}

.closebtn {
  width: 24px;
  height: 24px;
  -webkit-border-radius: 12px; /* width,heightの半分 */
  -moz-border-radius: 12px;
  border-radius: 12px;
  background-color: #ccc; /* 円の色 */
  padding: 0;
  border: none;
  cursor: pointer;
  position: relative;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  float: right;
  outline: none;
}

.closebtn span {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 100px;
  text-align: center;
}

.FbBtn {
  background-color: #3b5998;
  height: 47px;
  display: inline-block;
  position: relative;
  text-decoration: none;
  border-radius: 4px;
}

.FbBtn::after {
  content: "";
  position: absolute;
  top: 9px;
  left: 9px;
  width: 29px;
  height: 29px;
  background-image: url(/static/image/common/FB-Logo_white_29.png);
  background-repeat: no-repeat;
  background-size: 29px 29px;
}

.FbBtnLabel {
  color: #fff;
  position: relative;
  font-weight: bold;
  top: 13px;
  text-align: center;
  padding: 0 40px 0 60px;
}

.sectionBtn {
  width: 142px;
  height: 34px;

  .cheer_follow {
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 15px;
    font-size: 117%;
    font-weight: bold;
    border: 2px solid #45a036;
    border-radius: 5px;
    box-sizing: border-box;
    transition: all 0.2s ease-out;
    cursor: pointer;
  }

  .svg_follow {
    width: 12px;
    height: 14px;
    margin-right: 8px;
  }

  .follow {
    color: #45a036;
    background-color: #fff;
    outline: none;

    .cls-3 {
      fill: #45a036;
    }
  }

  .follow:hover {
    color: #fff;
    background: #45a036;
    text-decoration: none;

    .cls-3 {
      fill: #fff;
    }
  }

  .following {
    color: #fff;
    background-color: #45a036;
    outline: none;

    .cls-3 {
      fill: #fff;
    }
  }

  .following:hover {
    color: #45a036;
    background: #fff;
    text-decoration: none;

    .cls-3 {
      fill: #45a036;
    }
  }
}
</style>
